var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_11072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9028 12C3.48739 12 2.77968 12 2.27582 11.6979C1.94652 11.5004 1.68122 11.2181 1.51 10.8828C1.24802 10.3698 1.31844 9.69153 1.45928 8.33499C1.57685 7.20259 1.63564 6.63636 1.92472 6.22053C2.11452 5.94752 2.37122 5.72375 2.67214 5.56901C3.13048 5.33333 3.72126 5.33333 4.9028 5.33333H11.0975C12.2791 5.33333 12.8698 5.33333 13.3282 5.56901C13.6291 5.72375 13.8858 5.94752 14.0756 6.22053C14.3647 6.63636 14.4235 7.20259 14.541 8.33499C14.6819 9.69153 14.7523 10.3698 14.4903 10.8828C14.3191 11.2181 14.0538 11.5004 13.7245 11.6979C13.2206 12 12.513 12 11.0975 12",
    stroke: "#172B4D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 5.33333V3.99999C11.3332 2.74291 11.3332 2.11437 10.9426 1.72385C10.5521 1.33333 9.92357 1.33333 8.6665 1.33333H7.33317C6.07609 1.33333 5.44755 1.33333 5.05703 1.72385C4.6665 2.11437 4.6665 2.74291 4.6665 3.99999V5.33333",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32564 10.6667H6.67404C6.21719 10.6667 5.98875 10.6667 5.79439 10.7393C5.53524 10.836 5.31335 11.024 5.16397 11.2733C5.05194 11.4603 4.99654 11.7007 4.88573 12.1816C4.71259 12.933 4.62603 13.3087 4.6849 13.6099C4.76341 14.0116 5.00809 14.3516 5.34819 14.5316C5.60326 14.6667 5.96019 14.6667 6.67404 14.6667H9.32564C10.0395 14.6667 10.3964 14.6667 10.6515 14.5316C10.9916 14.3516 11.2363 14.0116 11.3148 13.6099C11.3736 13.3087 11.2871 12.933 11.114 12.1816C11.0032 11.7007 10.9477 11.4603 10.8357 11.2733C10.6863 11.024 10.4644 10.836 10.2053 10.7393C10.0109 10.6667 9.78251 10.6667 9.32564 10.6667Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.006",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_11072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a717cd4e1d6136ac9ddf14c37b7a81e7.svg";
export { ForwardRef as ReactComponent };